<template>
  <div>
    <div class="alert-bag justify-center">
      <v-alert :type="alert.type"
               dismissible
               class="alert-bag__alert"
               v-for="alert in alerts" :key="alert.id"
               transition="scale-transition"
               >
        {{ alert.message }}
      </v-alert>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'pinia'
import { useAlertStore } from '@/stores'

export default {
  name: 'alert-bag',
  props: {
    alerts: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...mapActions(useAlertStore, [
      'clearAlert',
    ]),
  },
}
</script>
